import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService, User, I18nModule } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable } from 'rxjs';
import { pairwise } from 'rxjs/operators';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomProfileService } from '../../../core/services/custom-profile.service';
import { CustomProductsService } from '../custom-products/custom-products.service';
import {CompanyModel} from '../../../core/model/company.model';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf, NgFor, TitleCasePipe } from '@angular/common';
@Component({
    selector: 'app-custom-groupcompanies',
    templateUrl: './custom-groupcompanies.component.html',
    styleUrls: ['./custom-groupcompanies.component.scss'],
    imports: [CommonPageBreadcrumbsComponent, NgIf, NgFor, TitleCasePipe, I18nModule]
})
export class CustomGroupcompaniesComponent implements OnInit {
  enableLoader = true;
  //groupcompanies: any;
  errorMessage: any;
  title: any;
  navigationData: string;
  user$: Observable<User>;
  userid: any;
  noData = false;
  usergroup: any;
  loggedinUser: any;
  customerId: any;
  groupcompanies: CompanyModel [] = [];
  constructor(
    private customProfileService: CustomProfileService,
    private translation: TranslationService,
    public toastService: ToastService,
    private router: Router, private route: ActivatedRoute,
    private userAccountFacade: UserAccountFacade,
    private customProductsService: CustomProductsService
  ) { }

  navigateToDetails(): any {
    this.router.navigate([`updateDetails`], { relativeTo: this.route });
  }

  ngOnInit(): void {
    this.customProductsService.getHomeLinkActive(false);
    this.customProductsService.scrollToTop();
    this.userAccountFacade.get().subscribe( (data: any) => {
      if (data) {
        this.userid = data.uid;
        this.usergroup = data.orgUnit.uid;
        this.getGroupCompanies();
        this.customProductsService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
          this.enableLoader = true;
          if (current != null) {
            if (previous !== current) {
              this.enableLoader = true;
              if (this.router.url === '/companies/myCompany/groupcompanies/detail') {
                this.getGroupCompanies();
              }
            }
          }
        });
      }
    });

    this.translation.translate('breadcrumb.groupCompanies.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.groupCompanies.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });

  }
  getGroupCompanies(): any {
    this.customProfileService.getGroupCompanies(this.usergroup).subscribe((res: any) => {
      if (res) {
        this.groupcompanies = [];
        this.noData = false;
        this.enableLoader = false;
       // this.groupcompanies = res;
        if (res.length === 0) {
          this.noData = true;
        }
        this.groupcompanies.push(new CompanyModel(res.myB2BUnits[0]));
      }
    }, (error) => {
      console.error('error caught in component');
      this.errorMessage = error;
      this.enableLoader = false;
    });
  }

}
